import { render, staticRenderFns } from "./keyword-blacklist.vue?vue&type=template&id=4828c6ea&"
import script from "./keyword-blacklist.vue?vue&type=script&lang=js&"
export * from "./keyword-blacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4828c6ea')) {
      api.createRecord('4828c6ea', component.options)
    } else {
      api.reload('4828c6ea', component.options)
    }
    module.hot.accept("./keyword-blacklist.vue?vue&type=template&id=4828c6ea&", function () {
      api.rerender('4828c6ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/content-manage/keyword-blacklist/keyword-blacklist.vue"
export default component.exports